/* eslint-disable max-len */
import React from 'react';
import { CamelCase } from '../../redux/helper/CamelCase';

export default function AddressHover({ type, setaddressPopup, address,NoChange }) {
    return (
        <div style={{zIndex: '1'}} className={`absolute top-[50px] ${type==='billing'?'left-0':'right-0'} bg-[#FFFFFF] rounded-lg address-more sm:px-5 px-3 sm:py-4 py-3 shadow-s7 w-[323px] z-[10] adderess-show45 show`}>
            <div className="flex items-center justify-between">
                <p className="sm:text-xs6 text-sm font-semibopld text-[#808285]">
                    {CamelCase(type)}
                    {' '}
                    address
                </p>
                {NoChange===true &&<button
                    onClick={() => setaddressPopup(true)}
                    type="button"
                    className="sm:text-xs6 text-sm font-semibold text-[#808285] change"
                    data-bs-toggle="modal"
                    data-bs-target="#changeaddressModal"
                >
                    Change
                    {' '}

                </button>}
            </div>
            <p className="sm:pr-14 pr-9 sm:pt-2 pt-1.5 sm:text-base text-sm font-normal text-[#15090E]">
                <p>
                    {address?.ADDRESS1}
                    ,
                </p>
                <p>
                    {address?.ADDRESS2}
                    ,
                    {address?.ADDRESS3}
                    ,
                    {address?.ADDRESS4}
                </p>
                <p>
                    {address?.CITY}-{address?.POSTAL_CODE}
                </p>
                <p>
                    {address?.STATE},{address?.COUNTRY},
                    {`GSTIN-${address?.ATTRIBUTE2 || address?.SITE_GSTIN || '-'}`}
                    {address?.LOCATION} 
                </p>
            </p>
        </div>
    );
}
